import React from 'react';
import './statistic.css'
const ModalStatistic = ({ data }) => {
    return (
        <div>
            <p className='modalText'>Статистика</p>
            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Дата</th>
                            <th>Время выхода</th>
                            <th>Время ухода</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                <td>{item.date}</td>
                                <td>{item['entry-time']}</td>
                                <td>{item['exit-time']}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </div>
    );
};

export default ModalStatistic;